import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Logo from './Logo';

// One-time curtain intro: black curtain slides away + PPR monogram + wordmark
export default function OnLoadCurtain() {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const played = sessionStorage.getItem('ppr_intro_played');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (played || reduce) { setShow(false); return; }
    const t = setTimeout(() => {
      sessionStorage.setItem('ppr_intro_played', '1');
      setShow(false);
    }, 2100);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[200] bg-black flex items-center justify-center overflow-hidden"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.6 } }}
          data-testid="onload-curtain"
        >
          {/* Top and bottom bars slide away */}
          <motion.div
            className="absolute top-0 left-0 right-0 h-1/2 bg-black origin-top"
            initial={{ scaleY: 1 }}
            animate={{ scaleY: 0 }}
            transition={{ delay: 1.55, duration: 0.9, ease: [0.87, 0, 0.13, 1] }}
          />
          <motion.div
            className="absolute bottom-0 left-0 right-0 h-1/2 bg-black origin-bottom"
            initial={{ scaleY: 1 }}
            animate={{ scaleY: 0 }}
            transition={{ delay: 1.55, duration: 0.9, ease: [0.87, 0, 0.13, 1] }}
          />

          <div className="relative z-10 flex flex-col items-center">
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
            >
              <Logo size={96} />
            </motion.div>
            <motion.div
              className="mt-6 overflow-hidden"
              initial={{ width: 0 }}
              animate={{ width: 'auto' }}
              transition={{ delay: 0.6, duration: 0.8, ease: [0.2, 0.8, 0.2, 1] }}
            >
              <div className="whitespace-nowrap font-mono text-[10px] tracking-[0.5em] text-white/70 uppercase">
                Ponthieu · Pose · Rénovation
              </div>
            </motion.div>
            <motion.div
              className="h-px bg-white/40 mt-6"
              initial={{ width: 0 }}
              animate={{ width: 220 }}
              transition={{ delay: 1.0, duration: 0.5 }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
